// Pending-upload count shown on the Dashboard (Section 10).

export default function UploadStatus({ pendingCount }) {
  if (pendingCount === 0) {
    return (
      <div className="flex items-center gap-2 text-ok text-sm">
        <span className="h-2 w-2 rounded-full bg-ok" />
        All sessions uploaded
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-amber text-sm">
      <span className="h-2 w-2 rounded-full bg-amber" />
      {pendingCount} session{pendingCount === 1 ? '' : 's'} waiting to upload
    </div>
  );
}
